import React from "react";

import {formatDate} from "../../utils/utils";

import "./StatisticsPage.scss";


const ClicksListElement = (props) => {
  let campaign = props.campaigns.find(item => item.id === props.click.campaign_id);
  if (!campaign)
    campaign = props.campaigns[0];

  return (
    <div className={'clicks-list__element'}>
      <div>
        {formatDate(props.click.time)}
      </div>
      <div>
        {campaign.display_name}
      </div>
      <div>
        {props.click.country_code}
      </div>
    </div>
  );
}

export default ClicksListElement;